import { MultiSelectPanelDropdown } from './../multiselect-panel/multiselect-panel.module';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
// import { AuthenticationModule } from "src/app/components/authentication/authentication.module";
import { SanitiseModule, SanitiseUrlPipe } from "src/app/pipes/sanitise-url.pipe";
import { ButtonModule } from "../buttons/button.module";
import { CardPrimaryComponent } from "./card-primary.component";
import { LazyLoadImageModule } from 'ng-lazyload-image';

@NgModule({
    declarations:[CardPrimaryComponent],
    imports:[ButtonModule,CommonModule, SanitiseModule,
      MultiSelectPanelDropdown,
      LazyLoadImageModule
        // AuthenticationModule, Vouch
    ],
    exports: [CardPrimaryComponent]
})
export class CardPrimaryModule{
    constructor(){

    }
}
